export default "__VITE_ASSET__22fa5296__"